var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { useCallback } from "react";
import { BaseComponentPlus, cssHelper } from "react-vextensions";
import { manager } from "../../Manager.js";
import { Link } from "../ReactComponents/Link.js";
import { Observer, RunInAction } from "../Store/MobX.js";
// todo: someday move the NavBar comp itself here (probably)
let NavBarButton = class NavBarButton extends BaseComponentPlus({}, { hovered: false }) {
    render() {
        let { page, subpage, text, active, style, onClick, children } = this.props;
        // let {_radiumStyleState: {main: radiumState = {}} = {}} = this.state as any;
        // let {_radiumStyleState} = this.state as any;
        const { hovered } = this.state;
        const largeVersion = manager.useExpandedNavBar();
        const currentPage = manager.store.main.page;
        active = active != null ? active : page == currentPage;
        const pageEntry = page != null ? manager.pageTree.children[page] : null;
        //const actionFunc = page ? (s: RootStore)=>{
        const actionFunc = page && pageEntry ? (s) => {
            if (page != currentPage) {
                s.main.page = page;
            }
            else {
                const pageStore = s.main[currentPage];
                const newSubpage = manager.pageTree.children[currentPage].DefaultChild;
                // go to the page root-contents, if clicking on page in nav-bar we're already on
                if (pageStore.subpage != newSubpage) {
                    //s.main[currentPage].subpage = null;
                    pageStore.subpage = newSubpage;
                }
                else {
                    if (newSubpage) {
                        const subpageEntry = pageEntry.children[newSubpage];
                        if (subpageEntry.actionIfActive) {
                            //runInAction("NavBarPageButton.subpage.actionIfActive", ()=>subpageEntry.actionIfActive(s));
                            subpageEntry.actionIfActive(s);
                        }
                    }
                    if (pageEntry.actionIfActive) {
                        pageEntry.actionIfActive(s);
                        //runInAction("NavBarPageButton.actionIfActive", ()=>pageEntry.actionIfActive(s));
                    }
                }
            }
            const pageStore = s.main[currentPage];
            if (subpage != null && subpage != pageStore.subpage) {
                pageStore.subpage = subpage;
            }
        } : null;
        const hoverOrActive = hovered || active;
        const { css } = cssHelper(this);
        return (React.createElement(Link, { actionFunc: actionFunc, onClick: onClick, onMouseEnter: useCallback(() => this.SetState({ hovered: true }), []), onMouseLeave: useCallback(() => this.SetState({ hovered: false }), []), style: css({
                height: "100%",
                display: "flex", alignItems: "center", justifyContent: "center",
                position: "relative", cursor: "pointer",
                lineHeight: largeVersion ? "45px" : "25px", color: "rgba(255,255,255,1)", padding: "0 15px", fontSize: 12, textDecoration: "none", opacity: 0.9,
            }, style) },
            text,
            children,
            hoverOrActive &&
                React.createElement("div", { style: css({ position: "absolute", left: 0, right: 0, bottom: 0, height: 2, background: "rgba(100,255,100,1)" }) })));
    }
};
NavBarButton = __decorate([
    Observer
], NavBarButton);
export { NavBarButton };
let NavBarPageButton = class NavBarPageButton extends BaseComponentPlus({}, {}) {
    render() {
        const { ...rest } = this.props;
        return (React.createElement(NavBarButton, { ...rest }));
    }
};
NavBarPageButton = __decorate([
    Observer
], NavBarPageButton);
export { NavBarPageButton };
let NavBarPanelButton = class NavBarPanelButton extends BaseComponentPlus({}, {}, { active: false }) {
    constructor() {
        super(...arguments);
        this.OnClick = (e) => {
            e.preventDefault();
            const { corner, panel, active } = this.PropsStateStash;
            RunInAction("NavBarPanelButton_OnClick", () => {
                if (corner == "top-left") {
                    manager.store.main.topLeftOpenPanel = active ? null : panel;
                }
                else {
                    manager.store.main.topRightOpenPanel = active ? null : panel;
                }
            });
        };
    }
    render() {
        const { text, onClick, panel, hasPage, corner, style, children } = this.props;
        const { topLeftOpenPanel, topRightOpenPanel } = manager.store.main;
        const active = (corner == "top-left" ? topLeftOpenPanel : topRightOpenPanel) == panel;
        this.Stash({ active });
        const { css } = cssHelper(this);
        return (React.createElement(NavBarButton, { page: hasPage ? panel : null, text: text, panel: true, active: active, onClick: e => {
                if (onClick) {
                    onClick(e);
                }
                this.OnClick(e);
            }, style: css(style) }, children));
    }
};
NavBarPanelButton = __decorate([
    Observer
], NavBarPanelButton);
export { NavBarPanelButton };
//# sourceMappingURL=NavBar.js.map